import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const SECTIONS = [
  { id: 'terms', title: '1. Agreement', body: [
    'By creating an account or purchasing from Lucky Scripts ("we", "us"), you agree to these Terms of Service. If you do not agree, do not purchase or use our products.',
    'You must tick the Terms of Service box at checkout. Ticking it confirms you have read, understood and accepted these terms.',
  ]},
  { id: 'products', title: '2. Digital Products', body: [
    'All products are digital configuration files and scripts (for XIM Matrix, Cronus Zen and similar devices) delivered instantly through your account dashboard.',
    'You are responsible for choosing the correct product and console version (e.g. PS5 or Xbox) before purchase. Please read the product description, including requirements such as "KBM ONLY", before buying.',
    'You must own a compatible device and any software needed to use the product. We do not supply hardware.',
  ]},
  { id: 'refund', title: '3. No Refunds — All Sales Final', body: [
    'Because products are digital and delivered instantly, ALL SALES ARE FINAL. We do not offer refunds, returns or exchanges for any reason, including change of mind, buying the wrong product or console version, incompatibility with your setup, game updates, or dissatisfaction with performance.',
    'VIP memberships are also non-refundable.',
    'Opening a chargeback or payment dispute for a purchase you made and received breaks these terms. If you do, we will permanently revoke your access to all products, VIP and Discord roles, and may ban your account.',
    'If a file is broken or will not download, contact us through Discord and we will help you or replace the file.',
  ]},
  { id: 'license', title: '4. License & Use', body: [
    'Each purchase gives you a personal, non-transferable, non-exclusive license to use the product on your own setup.',
    'You may not share, resell, redistribute, leak, upload or publicly post any product or file. Doing so ends your license immediately and permanently revokes your access, with no refund.',
    'All products remain the intellectual property of Lucky Scripts and their creators.',
  ]},
  { id: 'risk', title: '5. Use at Your Own Risk', body: [
    'Third-party input devices and scripts may break the terms of service of games, consoles or platforms. You use our products entirely at your own risk.',
    'We are not responsible for any account bans, suspensions, restrictions, lost progress or other consequences that result from using our products.',
    'Products are provided "as is". Performance can vary with game updates, settings and hardware. We do not guarantee that products will work with every future game or device update.',
  ]},
  { id: 'updates', title: '6. Updates & Availability', body: [
    'We may update, change or stop selling any product at any time. Updates are provided at our discretion.',
    'Lifetime VIP access means access for as long as Lucky Scripts runs the VIP program.',
  ]},
  { id: 'accounts', title: '7. Accounts', body: [
    'Keep your login details secure. You are responsible for all activity on your account. Account sharing is not allowed.',
    'We may suspend or terminate accounts that break these terms.',
  ]},
  { id: 'privacy', title: '8. Privacy', body: [
    'We store your email, order history and download activity so we can deliver your products and prevent abuse. Payments are processed securely by Stripe or PayPal. We never see or store your full card details.',
    'We do not sell your personal data.',
  ]},
  { id: 'liability', title: '9. Limitation of Liability & Changes', body: [
    'To the maximum extent permitted by law, our total liability for any claim is limited to the amount you paid for the product concerned.',
    'We may update these terms at any time. The version in force at the time of your purchase applies to that purchase.',
    'Questions? Contact us on Discord: discord.gg/luckyscripts',
  ]},
];

export default function Terms() {
  return (
    <div className="bg-grain relative min-h-screen text-white" data-testid="terms-page">
      <Navbar />
      <main className="relative mx-auto max-w-3xl px-6 pt-16 pb-24">
        <p className="text-xs uppercase tracking-[0.35em] text-brand font-mono">Legal</p>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-3">Terms of Service</h1>
        <p className="mt-3 text-sm text-white/50">Last updated 30 October 2026</p>
        <div className="mt-8 rounded-2xl border border-amber-400/30 bg-amber-400/[0.06] p-5 text-sm text-amber-100/90" data-testid="terms-summary">
          <span className="font-semibold text-amber-300">Summary:</span> All purchases are final and non-refundable. Products are for your personal use only and must not be shared or resold. You use them at your own risk.
        </div>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-24" data-testid={`terms-section-${s.id}`}>
              <h2 className="font-display font-bold text-lg md:text-lg text-white">{s.title}</h2>
              <div className="mt-3 space-y-3 text-sm text-white/65 leading-relaxed">
                {s.body.map((t) => <p key={t}>{t}</p>)}
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
